import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense, useRef } from 'react';
import { useGetZ3kSettingsData } from 'z3k-settings/provider/utils';
import { CircularProgress, Typography } from '@mui/material';
import { minimalZ3KConfig } from 'z3k-parser/lib';
import { Z3KDialogContent } from 'z3k-settings/index';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { createSelector } from '@reduxjs/toolkit';
import { selectDevices } from 'entities/device/lib';
import { selectStripItemsOfArray } from 'utils';
import { useLocation } from 'react-router';
const LazySettingsProviders = lazy(async () => import(
// webpackChunkName: 'z3k-app'
'z3k-settings/provider'));
export const getDevicesId = createSelector(selectDevices, selectStripItemsOfArray(['id']));
export const getFirstDeviceIfOne = createSelector(getDevicesId, (devices) => (devices.length == 1 ? devices[0].id : null));
export function Z3kSettingsDialog() {
    let device_id = useAppSelector((state) => state.router_device_id);
    const first_device = useAppSelector(getFirstDeviceIfOne);
    const location = useLocation();
    const isClimatic = useRef(!!location.state?.is_climatic);
    if (device_id == null && first_device != null) {
        device_id = first_device;
    }
    const { device, z3k_state } = useGetZ3kSettingsData(device_id);
    if (device_id == null || device == null) {
        return (_jsx(Typography, { variant: "h6", color: "error", children: "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E" }));
    }
    const { device_type, hardware_type, z3k_config } = device;
    if (device_type == null || hardware_type == null) {
        return (_jsx(Typography, { variant: "h6", color: "error", children: "\u0412\u044B\u0432\u0435\u0434\u0438\u0442\u0435 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u043D\u0430 \u0441\u0432\u044F\u0437\u044C" }));
    }
    return (_jsx(Suspense, { fallback: _jsx(CircularProgress, { size: 50, color: "primary", sx: {
                zIndex: 401,
                position: 'absolute',
                left: 'calc(50% - 25px)',
                top: 'calc(50% - 25px)',
            } }), children: _jsx(LazySettingsProviders, { author: 2, device_id: device_id, device: device, z3k_state: z3k_state, device_type: device_type?.code, hardware_type: hardware_type?.code, z3k_config: z3k_config ?? minimalZ3KConfig, device_ui_settings: device.ui_settings, need_open_for_climatic: isClimatic.current, children: _jsx(Z3KDialogContent, {}) }) }));
}
